<template>
    <gls-pickup-points @input="setPickupPoint" :pickup-point="pickupPoint" :show-parcel-shops="0" :show-parcel-lockers="1"></gls-pickup-points>
</template>

<script>
export default {
    name: 'GlsParcelLocker',

    props: {
        pickupPoint: {
            default: null
        }
    },

    methods: {
        setPickupPoint(id) {
            this.$emit('input', id)
        },
    }
}
</script>
